module.exports = __webpack_public_path__ + "about_bg.dff6f06b0819f86e29de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about_bg.png
// module id = 468
// module chunks = 1